import { type MemberHistory, type MemberProfile } from "../../api/members";
import { DataList } from "../DataList";
import { MemberTrajectory } from "./MemberTrajectory";

interface MemberProfileSectionsProps {
  profile: MemberProfile;
  history: MemberHistory;
  memberId: string;
  canWriteDepartments: boolean;
}

function formatDate(value: string | null): string {
  if (!value) return "Não informado";
  const date = new Date(value.includes("T") ? value : `${value}T12:00:00`);
  return new Intl.DateTimeFormat("pt-BR", { dateStyle: "medium" }).format(date);
}

function categoryLabel(category: "colaborador" | "efetivo"): string {
  return category === "efetivo" ? "Efetivo" : "Colaborador";
}

export function MemberProfileSections({ profile, history, memberId, canWriteDepartments }: MemberProfileSectionsProps) {
  return (
    <div className="member-profile-sections">
      <section className="member-profile-section" aria-labelledby="member-contact-title">
        <h2 id="member-contact-title">Identificação e contato</h2>
        <DataList
          items={[
            { label: "Nome completo", value: profile.full_name },
            { label: "Nome social", value: profile.preferred_name ?? "Não informado" },
            { label: "Usuário ativo", value: profile.username ?? "Sem usuário ativo" },
            { label: "E-mail", value: profile.email ?? "Não informado" },
            { label: "Telefone", value: profile.phone ?? "Não informado" },
            { label: "Data de nascimento", value: formatDate(profile.birth_date) },
            { label: "CPF", value: profile.cpf },
          ]}
        />
      </section>

      <section className="member-profile-section" aria-labelledby="member-membership-title">
        <h2 id="member-membership-title">Vínculo institucional</h2>
        <p className="member-profile-section__hint">
          Situação e cargo eletivo ativo aparecem no cabeçalho, acima.
        </p>
        <DataList
          columns={1}
          items={[
            { label: "Categoria", value: categoryLabel(profile.membership_category) },
            { label: "Efetivo desde", value: formatDate(profile.effective_since) },
          ]}
        />
      </section>

      <section className="member-profile-section" aria-labelledby="member-trajectory-title">
        <h2 id="member-trajectory-title">Trajetória institucional</h2>
        <MemberTrajectory
          categoryHistory={history.category_history}
          departmentAssignments={profile.department_assignments}
          effectiveSince={profile.effective_since}
          memberId={memberId}
          canWriteDepartments={canWriteDepartments}
        />
      </section>
    </div>
  );
}
